var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container-sarah"},[_c('main-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }